import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuth0User } from './useAuth0User';
import useRememberLoginOrganisation from './useRememberLoginOrganisation';
import { useRememberLoginOrganisationForLocation } from 'api/hooks/useLocationSetting';
import { setLastUsedOrgId } from './useLastUsedOrgId';

// persists the org used to sign in so the next login can skip auth0's "enter your org" screen
export const useRememberLastLoginOrganisation = (): void => {
  const { isAuthenticated } = useAuth0();
  const auth0User = useAuth0User();
  const [rememberLocally] = useRememberLoginOrganisation();
  const { forLocation: rememberForLocation } = useRememberLoginOrganisationForLocation();

  useEffect(() => {
    if (!isAuthenticated || (!rememberLocally && !rememberForLocation)) {
      return;
    }

    const orgId = auth0User.isAuthenticated ? auth0User.org_id : undefined;
    if (!orgId) {
      // e.g. some SSO connections don't issue an org_id claim
      console.warn('Cannot remember the login organisation: no org_id claim found on the auth0 user.');
      return;
    }

    setLastUsedOrgId(orgId);
  }, [isAuthenticated, rememberLocally, rememberForLocation, auth0User]);
};
